export const animationKeyFrames = {
  title: [
    { offset: 0, textShadow: '0 0 0em var(--animation-color-0)' },
    {
      offset: 0.5,
      color: 'var(--animation-color-50)',
      textShadow: '0 0 0.3em var(--animation-color-0)',
    },
    {
      offset: 1,
      color: 'var(--animation-color-0)',
      textShadow: '0 0 0.3em var(--animation-color-100)',
    },
  ],
  name: [
    { offset: 0, textShadow: '0 0 0em var(--animation-color-0)' },
    {
      offset: 0.5,
      color: 'var(--animation-color-50)',
      textShadow: '0 0 0.3em var(--animation-color-0)',
    },
    {
      offset: 1,
      color: 'var(--animation-color-0)',
      textShadow: '0 0 0.3em var(--animation-color-100)',
    },
  ],
  response: [
    { offset: 0, color: 'var(--animation-color-0)' },
    {
      offset: 0.5,
      color: 'var(--animation-color-100)',
      textShadow: '0 0 0em var(--animation-color-0)',
    },
    {
      offset: 1,
      color: 'var(--animation-color-100)',
      textShadow: '0 0 0em var(--animation-color-100)',
    },
  ],
};
